export default "__VITE_ASSET__C9g_J46___"